import React from 'react';

import {
    yMapHintContainer, yMapHintDescription, yMapHintInfo, yMapHintTitle
} from '@search/ymap/src/hint';
import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatAreaRange } from '@search/helpers/src/formatArea';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapFlatMultiProps } from './FlatMultiProps';

export function OfferYMapFlatMulti({
    minPrice,
    minArea,
    maxArea,
    count,
    coordinates,
    url,
    id,
    isActive,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest,
    isNewBuilding
}: OfferYMapFlatMultiProps) {
    const realtyStr = declensionByNumber(count, [ 'квартира', 'квартиры', 'квартир' ]);

    const hintLayout = yMapHintContainer(`
        ${yMapHintInfo(`
            ${yMapHintTitle(`${count} ${realtyStr}`)}
            ${minArea && maxArea ? yMapHintDescription(formatAreaRange({ minArea, maxArea })) : ''}
        `)}
    `);

    const minPriceStr = formatPrice({
        value: minPrice.rubPrice ?? minPrice.value,
        currency: minPrice.rubPrice ? Currency.RUB : minPrice.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        dataTest={dataTest}
        targetBlank={targetBlank}
        onClick={onClick}
        isActive={isActive}
        title={`от ${minPriceStr}`}
        total={String(count)}
        theme={isNewBuilding ? 'green' : undefined}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
    />);
}
